import { render, staticRenderFns } from "./reply-memo.vue?vue&type=template&id=e79fe3e0&"
import script from "./reply-memo.vue?vue&type=script&lang=js&"
export * from "./reply-memo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports